import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _once from 'lodash/once';
import * as actions from '../actions/followCompanyActions.js';

/**
 * Dummy component that listens for route changes
 * and handles actions sent through query params
 */

class QueryActionHandler extends Component {
    static propTypes = {
        profile: PropTypes.object.isRequired,
        followCompany: PropTypes.func.isRequired,
        unfollowCompany: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
    };

    componentDidMount() {
        const searchParams = new URLSearchParams(this.props.location.search);
        if (searchParams.get('action')) {
            this.handleAction(searchParams.get('action'));
        }
    }

    // IMPORTANT
    shouldComponentUpdate(nextProps) {
        return (
            this.props.location !== nextProps.location &&
            Boolean(
                new URLSearchParams(nextProps.location.search).get('action')
            )
        );
    }

    componentDidUpdate() {
        this.handleAction(
            new URLSearchParams(this.props.location.search).get('action')
        );
    }

    handleAction = _once((action) => {
        const {
            profile: {
                profile: { id },
            },
            history,
            followCompany,
            unfollowCompany,
            location,
        } = this.props;
        if (action === 'follow') {
            followCompany(id);
            history.push(location.pathname);
        } else if (action === 'unfollow') {
            unfollowCompany(id);
            history.push(location.pathname);
        }
    });

    render() {
        return null;
    }
}

export default connect(
    (state) => ({
        profile: state.profile,
    }),
    (dispatch) => ({
        followCompany(id) {
            dispatch(actions.followCompany(id));
        },
        unfollowCompany(id) {
            dispatch(actions.unfollowCompany(id));
        },
    })
)(withRouter(QueryActionHandler));
